<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#B71C1C">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="750"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar 
            size="30">
            <v-img
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#B71C1C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-2">
            {{ form.id === '' ? 'Tambah' : 'Ubah' }} Dokter Online
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#B71C1C">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <div v-if="step_online === 1"
          class="pt-2 px-4">
          <v-text-field 
            dense
            single-line
            hide-details
            color="#B71C1C"
            placeholder="Cari . . ."
            append-icon="mdi-magnify"
            clearable
            v-model="search_doctor"
            vvvv-uppercase
            @click:clear="search_doctor = ''; fetchDoctor();"
            v-on:keyup.enter="fetchDoctor()">
          </v-text-field>
        </div>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <v-list v-if="step_online === 1"
                flat 
                dense
                color="transparent">
                <v-list-item-group
                  v-model="selected.doctor"
                  multiple>
                  <template>
                    <v-skeleton-loader
                      v-for="(item, index) in process.doctor ? 8 : list.doctor"
                      :key="index"
                      class="ma-auto"
                      :loading="process.doctor"
                      type="list-item-avatar-three-line">
                      <div>
                        <v-list-item v-if="!process.doctor && list.doctor.length > 0"
                          :value="item"
                          class="mb-2 pa-0"
                          style="background: #FFFFFF40; border-radius: 10px;">
                          <template v-slot:default="{ active }">
                            <v-list-item-avatar 
                              tile 
                              size="60"
                              class="mt-3"
                              style="box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;">
                              <v-img 
                                style="border-radius: 5px;"
                                alt="kominfo" 
                                :src="item.image === '' ? require('@/assets/image/member-default.jpg') : item.image"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#B71C1C">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title
                                class="body-1 font-weight-bold color-default"
                                style="margin-bottom: 6px;">
                                {{ item.fullname }}
                              </v-list-item-title>

                              <v-list-item-subtitle
                                class="caption font-weight-light">
                                <div
                                  class="mb-1 d-flex align-center">
                                  <v-icon x-small>mdi-email-outline</v-icon>

                                  <span
                                    class="ml-1">
                                    {{ item.email }}
                                  </span>
                                </div>

                                <div
                                  class="d-flex align-center">
                                  <v-icon x-small>mdi-phone-outline</v-icon>

                                  <span
                                    class="ml-1">
                                    {{ item.phone }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-checkbox 
                                color="#B71C1C"
                                :input-value="active">
                              </v-checkbox>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </div>
                    </v-skeleton-loader>
                  </template>
                </v-list-item-group>
              </v-list>

              <v-list v-if="step_online === 2 && form.id === ''"
                flat 
                dense
                three-line
                color="transparent">
                <v-list-item-group>
                  <template>
                    <v-list-item 
                      v-for="(item, index) in form.list"
                      :key="index"
                      :class="index >= form.list.length - 1 ? 'mb-1' : 'mb-4'"
                      class="pa-0"
                      style="background: #FFFFFF40; border-radius: 10px;">
                      <v-list-item-avatar 
                        tile 
                        size="60"
                        class="mt-2"
                        style="box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;">
                        <v-img 
                          style="border-radius: 5px;"
                          alt="kominfo" 
                          :src="item.user_image === '' ? require('@/assets/image/member-default.jpg') : item.user_image"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#B71C1C">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          class="body-1 font-weight-bold color-default"
                          style="margin-bottom: 6px;">
                          {{ item.user_fullname }}
                        </v-list-item-title>

                        <v-list-item-subtitle
                          class="caption font-weight-light">
                          <div
                            class="mb-1 d-flex align-center">
                            <v-icon x-small>mdi-email-outline</v-icon>

                            <span
                              class="ml-1">
                              {{ item.user_email }}
                            </span>
                          </div>

                          <div
                            class="d-flex align-center">
                            <v-icon x-small>mdi-phone-outline</v-icon>

                            <span
                              class="ml-1">
                              {{ item.user_phone }}
                            </span>
                          </div>
                        </v-list-item-subtitle>

                        <v-divider
                          class="mt-3"
                          style="1px solid #e0e0e0;" />

                        <v-row>
                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Tanggal
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              :ref="`picker${index}`"
                              min-width="290px"
                              max-width="290px"
                              transition="scale-transition"
                              offset-y
                              :nudge-right="40"
                              :close-on-content-click="false"
                              v-model="item.picker">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  :name="`date${index}`" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-model="item.date"
                                    vvvv-uppercase
                                    readonly
                                    outlined
                                    dense
                                    color="#B71C1C"
                                    placeholder="Contoh. 2022-10-13"
                                    hide-details
                                    clearable
                                    @click:clear="item.date = ''"
                                    v-on="on"
                                    v-bind="attrs"
                                    :success="item.date !== '' && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Tanggal {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="item.date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-date-picker 
                                color="#B71C1C"
                                v-model="item.date"
                                @input="item.picker = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Jam Mulai
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              :ref="`start${index}`"
                              v-model="item.time.start"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  :name="`start${index}`" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. 08:00"

                                    clearable
                                    @click:clear="item.start_time = ''"
                                    
                                    v-model="item.start_time"
                                    vvvv-uppercase
                                    :success="item.start_time !== '' && item.start_time !== null && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Jam Mulai {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="item.start_time !== '' && item.start_time !== null && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="item.time.start"
                                v-model="item.start_time"
                                full-width
                                format="24hr"
                                color="#B71C1C"
                                @click:minute="item.time.start = false; item.start_time = `${item.start_time}:00`;">
                              </v-time-picker>
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Jam Selesai
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              :ref="`end${index}`"
                              v-model="item.time.end"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  :name="`end${index}`" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. 08:00"

                                    clearable
                                    @click:clear="item.end_time = ''"
                                    
                                    v-model="item.end_time"
                                    vvvv-uppercase
                                    :success="item.end_time !== '' && item.end_time !== null && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Jam Mulai {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="item.end_time !== '' && item.end_time !== null && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="item.time.end"
                                v-model="item.end_time"
                                full-width
                                format="24hr"
                                color="#B71C1C"
                                @click:minute="item.time.end = false; item.end_time = `${item.end_time}:00`;">
                              </v-time-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>

              <v-list v-if="step_online === 2 && form.id !== ''"
                flat 
                dense
                three-line
                color="transparent">
                <v-list-item-group>
                  <template>
                    <v-list-item 
                      class="pa-0"
                      style="background: #FFFFFF40; border-radius: 10px;">
                      <v-list-item-avatar 
                        tile 
                        size="60"
                        class="mt-2"
                        style="box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;">
                        <v-img 
                          style="border-radius: 5px;"
                          alt="kominfo" 
                          :src="form.user_image === '' ? require('@/assets/image/member-default.jpg') : form.user_image"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#B71C1C">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          class="body-1 font-weight-bold color-default"
                          style="margin-bottom: 6px;">
                          {{ form.user_fullname }}
                        </v-list-item-title>

                        <!-- <v-list-item-subtitle
                          class="caption font-weight-light">
                          <div
                            class="mb-1 d-flex align-center">
                            <v-icon x-small>mdi-email-outline</v-icon>

                            <span
                              class="ml-1">
                              {{ item.user_email }}
                            </span>
                          </div>

                          <div
                            class="d-flex align-center">
                            <v-icon x-small>mdi-phone-outline</v-icon>

                            <span
                              class="ml-1">
                              {{ item.user_phone }}
                            </span>
                          </div>
                        </v-list-item-subtitle> -->

                        <v-divider
                          class="mt-3"
                          style="1px solid #e0e0e0;" />

                        <v-row>
                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Tanggal
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              ref="picker"
                              min-width="290px"
                              max-width="290px"
                              transition="scale-transition"
                              offset-y
                              :nudge-right="40"
                              :close-on-content-click="false"
                              v-model="form.picker">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="date" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-model="form.date"
                                    vvvv-uppercase
                                    readonly
                                    outlined
                                    dense
                                    color="#B71C1C"
                                    placeholder="Contoh. 2022-10-13"
                                    hide-details
                                    clearable
                                    @click:clear="form.date = ''"
                                    v-on="on"
                                    v-bind="attrs"
                                    :success="form.date !== '' && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Tanggal {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form.date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-date-picker 
                                color="#B71C1C"
                                v-model="form.date"
                                @input="form.picker = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Jam Mulai
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              ref="start"
                              v-model="form.time.start"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="start" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. 08:00"

                                    clearable
                                    @click:clear="form.start_time = ''"
                                    
                                    v-model="form.start_time"
                                    vvvv-uppercase
                                    :success="form.start_time !== '' && form.start_time !== null && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Jam Mulai {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form.start_time !== '' && form.start_time !== null && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="form.time.start"
                                v-model="form.start_time"
                                full-width
                                format="24hr"
                                color="#B71C1C"
                                @click:minute="form.time.start = false; form.start_time = `${form.start_time}:00`;">
                              </v-time-picker>
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="4">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Jam Selesai
                              <span class="error--text">
                                (wajib diisi)
                              </span>
                            </div>

                            <v-menu
                              ref="end"
                              v-model="form.time.end"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="end" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. 08:00"

                                    clearable
                                    @click:clear="form.end_time = ''"
                                    
                                    v-model="form.end_time"
                                    vvvv-uppercase
                                    :success="form.end_time !== '' && form.end_time !== null && valid"
                                    :error-messages="errors">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Jam Mulai {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form.end_time !== '' && form.end_time !== null && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="form.time.end"
                                v-model="form.end_time"
                                full-width
                                format="24hr"
                                color="#B71C1C"
                                @click:minute="form.time.end = false; form.end_time = `${form.end_time}:00`;">
                              </v-time-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-form>
          </ValidationObserver>

          <v-alert v-if="message.error.length > 0"
            type="error" 
            dense
            text 
            prominent>
            {{ message.error }}
          </v-alert>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn v-if="step_online === 1"
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="step_online = 2; toPushDoctor()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Selanjutnya
          </v-btn>

          <v-btn v-if="step_online === 2"
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; selected.doctor = []; form = []; step_online = 0;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="450"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="30">
            <v-img
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#B71C1C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-2">
            Hapus Data
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#B71C1C">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data Dokter Online yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col 
                  cols="12" 
                  md="8" 
                  class="d-flex align-center">
                  <!-- ADD -->
                  <div class="mr-3">
                    <v-btn
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                      @click="dialog.form = true; detail = {}; reset(); fetchDoctor(); step_online = 1;">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah
                      </span>
                    </v-btn>
                  </div>

                  <!-- EDIT -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; detail = selected.row[0]; reset(selected.row[0]); step_online = 2;">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>

                  <!-- DELETE -->
                  <div class="mr-3" v-if="selected.row.length > 0">
                    <v-btn
                      elevation="0"
                      style="background: #f4403433;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                      @click="toDelete()">
                      <v-icon size="18">mdi-delete-circle-outline</v-icon>

                      <span class="ml-1">
                        Hapus
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col 
                  cols="12" 
                  md="4" 
                  class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#B71C1C"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    vvvv-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '330px' : '258px'})`"
              :show-select="checkbox_select"
              :single-select="false"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="configHeaders"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template
                v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                v-slot:[`item.${header.value}`]="{ value }">
                {{ rowFormat(header.format, value) }} 
              </template>

              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        show: false,
        dialog: {
          snackbar: false,
          fullscreen: false,
          form: false,
          delete: false
        },
        search: '',
        search_doctor: '',
        selected: {
          row: [],
          delete: [],
          doctor: []
        },
        checkbox_select: true,
        options: {},
        headers: [],
        detail: {},
        list: {
          data: [],
          doctor: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        step_online: 1,
        form: {
          // LIST / MULTIPLE
          list: [],

          id: '',
          user_id: '',
          date: '',
          start_time: '',
          end_time: '',
          picker: false,
          time: {
            start: false,
            end: false
          }
        },
        process: {
          load: false,
          form: false,
          delete: false,
          doctor: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('doctor/schedule_online', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'user_fullname',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal',
                width: '200px',
                value: 'date',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Mulai',
                width: '200px',
                value: 'start_time',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Selesai',
                width: '200px',
                value: 'end_time',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      },
      async fetchDoctor () {
        this.process.doctor = true

        let params = {
          search: this.search_doctor,
          is_verified: 1,
          level: 'doctor',
          limit: 10000
        }

        await get('user', { params })
        .then(response => {
          let res = response.data

          this.process.doctor = false
            
          if (res.code === 200) {
            this.list.doctor = res.data
          }
        })
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.selected.doctor = []
        
        this.form = {
          // LIST / MULTIPLE
          list: [],
          
          id: item !== undefined ? item.id : '',
          user_id: item !== undefined ? item.user_id : '',
          user_fullname : item !== undefined ?  item.user_fullname : '',
          // user_email : item !== undefined ?  item.email : '',
          // user_phone : item !== undefined ?  item.phone : '',
          user_image : item !== undefined ?  item.user_image : '',
          date: item !== undefined ? item.date : '',
          start_time: item !== undefined ? item.start_time : '',
          end_time: item !== undefined ? item.end_time : '',
          picker: false,
          time: {
            start: false,
            end: false
          }
        }

        this.process.form = false

        this.message.error = ''
      },
      toPushDoctor () {
        this.selected.doctor.map(obj => {
          this.form.list.push({
            user_id : obj.id,
            user_fullname : obj.fullname,
            user_email : obj.email,
            user_phone : obj.phone,
            user_image : obj.image,
            date : '',
            start_time : '',
            end_time : '',
            picker: false,
            time: {
              start: false,
              end: false
            }
          })
        })
      },
      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'doctor/schedule_online/create_bulk' : 'doctor/schedule_online/update',
              forms = this.form.id === '' ? {
                data_bulk: this.form.list
              } : this.form

          // SAVE TO REST API
          await post(url, {
            data: forms
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`doctor/schedule_online/delete`, {
          data: {
            ids: this.selected.delete
          }
        }).then(response => {
          let res = response.data

          if (res.code === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>